module.exports = __webpack_public_path__ + "img/meditation.18a1769b.svg";